import moment from 'moment'
import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
const uuidv4 = require('uuid/v4');

function momentWithHM(date, hours, minutes) {
  let m = moment(date);
  m.hours(hours);
  m.minutes(minutes);
  m.seconds(0);
  return m;
}

export default {
  formateTime(hours, minutes) {
    let formate = momentWithHM(new Date(), hours, minutes)

    return formate.format("HH:mm:ss");
  },
  formateDatetime(date, hours, minutes) {
    let formate = momentWithHM(date, hours, minutes);

    return formate.format("YYYY-MM-DD HH:mm:ss")
  },
  reportLog(vue, err) {
    const code = uuidv4();
    const f = {
      name: err.name,
      message: err.message,
      // source: err.toSource(),
      code: code,
      lineNumber: err.lineNumber,
      columnNumber: err.columnNumber,
      fileName: err.fileName
    }
    vue.$http.post('error/log', {
      data: f
    }).catch(() => {
      console.log('no loop error...');
    });
    return code;
  }
}
